import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'

//import store from './app/store'
import { createStore,applyMiddleware,compose } from 'redux';
import reducers from './reducers'
import thunk from 'redux-thunk';
import App from './App';
import './index.css';

const store = createStore(reducers,compose(applyMiddleware(thunk)));
ReactDOM.render(
  <Provider store={store}>
  <App />
  </Provider>,
  document.getElementById('root')
);